import loadServiceVideoProducer from './loadServiceVideoProducer';
import VideoProducerModel from './videoProducerModel';

export default async function videoProducerManager(url) {
  const dataVideoProducer = await loadServiceVideoProducer(url);
  const videoProducerModel = new VideoProducerModel(dataVideoProducer);
  return videoProducerModel;
}
